import { AppState, Dispatch } from '../../types'
import { connect } from 'react-redux'
import { changeIframeState } from './actions'
import { IframeLoadingState } from '@mulesoft/monitoring-center-components/lib/components/Iframe/IframeLoadingState'
import { OptionalExceptFor } from '../../types/util'

import {
  IEventProps,
  Iframe,
  IValueProps,
  Props
} from '@mulesoft/monitoring-center-components/lib/components/Iframe/Iframe'

export type ExternalProps = OptionalExceptFor<Props, 'id' | 'src' | 'displayedStrategy' | 'onIframeStateChange'>

const changeIframeStateDispatcher = (dispatch: Dispatch, ownProps: ExternalProps) => {
  return (state: IframeLoadingState, uri: string, iframe?: HTMLIFrameElement): void => {
    dispatch(changeIframeState(state, iframe ? iframe.src : uri))
    ownProps.onIframeStateChange(state, uri, iframe)
  }
}

const mapDispatch = (dispatch: Dispatch, ownProps: ExternalProps): IEventProps => ({
  displayedStrategy: ownProps.displayedStrategy,
  onIframeStateChange: changeIframeStateDispatcher(dispatch, ownProps),
})

const mapState = (rootState: AppState, ownProps: ExternalProps): IValueProps => ({
  id: ownProps.id,
  src: ownProps.src,
  eventHandlers: ownProps.eventHandlers ? ownProps.eventHandlers : [],
  sameOrigin: ownProps.sameOrigin ? ownProps.sameOrigin : true,
})

export default connect(mapState, mapDispatch)(Iframe)
